import apis from "./apis";
import DAASLAYER from "./daasLayer";
import {
  emLineOthersRevoked,
  emLineOwnerRevoked,
  emLineSharedOwner,
  emLineSharedWithOthers,
  emLineUserRevoked,
  emLineUserWithTMOID,
  emLineWithOutTMOID,
} from "./Templates";
import { ComponentsContent } from "app/common/NumberCard/NumberCardContent";
import { Devices } from "./ManageDevices/reducers/index.model";
export interface Lines {
  accountStatus: string;
  granteeEmail: string;
  grantor: string;
  grantee: string;
  givenName: string;
  ban: string;
  customerType: string;
  imsi: string;
  isLineGrantable: string;
  isPrimaryMSISDN: boolean;
  msisdn: string;
  permissionType: string;
  LineSubType: string;
  LineType: string;
  MSISDN: string;
  NAPLineType: string;
  Icon: string;
  isEditable: boolean;
  isShareble: boolean;
}

export interface ExplicitPermissions {
  givenName: string;
  grantee: string;
  granteeEmail: string;
  grantor: string;
  grantorEmail: string;
  grantedPrivilege: string;
  msisdn: string;
}
export interface LineDetails {
  id: Number;
  category: string;
  lines: Lines[];
  helpText: string;
}
export interface ImplicitUser {
  IAMEmail: string;
}
export interface ShareLine {
  granteeEmail: string;
  grantorEmail: string;
  msisdn: string;
}

export interface ImplicitPermissions {
  lines: Lines[];
  user: ImplicitUser;
}

const SDK = function (this: any) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  let code = "" ;
  let USN = "";
  if (urlSearchParams.has("code")) {
    code = urlSearchParams.get("code") || "";
    USN = urlSearchParams.get("session_num") || "";
    sessionStorage.setItem("usn", USN);
  }
  this.initiateApp = async () => {
    return await DAASLAYER.registerToken(code);
  };

  // Need to remove this count
  let count = 0;
  const config: any = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
    xmlHeaders: {
      "Content-Type": "text/xml",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
    token: sessionStorage.getItem("token") || "",
    userInfo: {},
    userLines: {},
  };

  this.setToken = (t: string) => {
    config.headers.Authorization = `Bearer ${t}`;
    config.token = t;
  };

  this.getToken = () => config.token;

  this.getUserInfo = async () => {
    if (!sessionStorage.getItem("authInfo")) {
      return;
    }
    return (config.userInfo = await DAASLAYER.HTTP(
      apis.userInfo,
      "GET",
      "fetch user Info"
    ));
  };
  this.getUserLines = async () => {
    const userEmail = config.userInfo?.TMO_ID_profile?.email;
    let permissionInfo: any = await DAASLAYER.HTTP(
      apis.permissionInfo + encodeURIComponent(userEmail),
      "GET",
      "fetch lines"
    );
    let explicitPermissions: string[] = [];
    let implicitPermissions: string[] = [];
    let lines_details: LineDetails[] = [];
    let assignedLines: Lines[] = [];
    let unAssignedLines: Lines[] = [];
    let dublicateLines: Lines[] = [];
    let sharedLines: Lines[] = [];
    let implicitPermLines: Lines[] = [];
    if (!permissionInfo?.errors) {
      if (permissionInfo && !permissionInfo?.description) {
        explicitPermissions = permissionInfo.explicitPermissions
          ? permissionInfo.explicitPermissions.map(
              (r: ExplicitPermissions) => r.msisdn
            )
          : [];
        permissionInfo.implicitPermissions?.[0].lines.map(async (r: Lines) => {
          implicitPermissions.push(r.msisdn);
        });
        // const linesToCheck = [
        //   ...explicitPermissions,
        //   ...implicitPermissions,
        // ].slice(0,50).map((i) => "msisdns[]=" + i);
        // const url = apis.lineManagement + "&" + linesToCheck.join("&");
        const distinctLine = [
          ...new Set(
            [...explicitPermissions, ...implicitPermissions]
              .map((i) => i)
              .map((x) => x)
          ),
        ];
        if (permissionInfo.implicitPermissions?.[0]) {
          implicitPermLines = [...permissionInfo.implicitPermissions[0].lines];
        }
        //const missingMSISDN=distinctLine.filter((msisdn:string)=>!implicitPermLines.find((line:Lines)=>msisdn===line.msisdn))
        // if(missingMSISDN.length>0){
        //   missingMSISDN.map(async(line:string)=>{
        //     let missingInfo: any = await DAASLAYER.HTTP(apis.lineDelveDetail + line, 'GET');
        //     if(missingInfo && missingInfo.implicitPermissions[0]){
        //      implicitPermLines=[...implicitPermLines,...missingInfo.implicitPermissions[0]?.lines]
        //     }
        //   })

        // }

        //UDD-593
        const linesToCheckAll = distinctLine.map((i) => "msisdns[]=" + i);
        let loop =
          linesToCheckAll.length > 0
            ? Math.ceil(linesToCheckAll.length / 50)
            : 0;
        let loopCount = 1;
        let lineDetails: Lines[] = [];
        let lineDetailsError: any;
        while (loop >= loopCount) {
          let startIndex =
            loopCount > 1 ? (loopCount - 1) * 50 + 1 : (loopCount - 1) * 50;
          let endIndex = loopCount > 1 ? startIndex + 49 : startIndex + 50;
          let url_lineDetails =
            apis.lineManagement +
            "&" +
            linesToCheckAll.slice(startIndex, endIndex).join("&");
          loopCount = loopCount + 1;
          let lineDetailsResponse: any = await DAASLAYER.HTTP(
            url_lineDetails,
            "GET",
            "fetch line details"
          );
          if (!lineDetailsResponse?.errors) {
            // mock res
            // lineDetailsResponse = lineDetailsResponse.map((obj:any) => {
            //   if(obj.MSISDN === '14254369353'){
            //     return {MSISDN:obj.MSISDN, LineType: "UNKNOWN", NAPLineType: "MI"};
            //   }
            //   if(obj.MSISDN === '14253705358'){
            //     return {MSISDN:obj.MSISDN, LineType: "autoattendant", LineSubType: ""};
            //   }
            //   if(obj.MSISDN === '14253705355'){
            //     return {MSISDN:obj.MSISDN, LineType: "conference", LineSubType: ""};
            //   }
            //   return obj;
            // })
            //console.log(lineDetailsResponse, lineDetails);
            lineDetails = lineDetails.concat(lineDetailsResponse);
          } else {
            lineDetailsError = lineDetailsResponse;
          }
        }
        // let lineDetails: any = await DAASLAYER.HTTP(
        //   url,
        //   "GET",
        //   "fetch line details"
        // );
        if (!lineDetailsError?.errors) {
          // returning fake data based on count
          // NEED TO REMOVE BELOW LINES
          count++;
          // NEED TO REMOVE TILL HERE
          const required_linesTypes = [
            "VIRTUAL",
            "NORMAL",
            "UNKNOWN",
            "LINELINK",
            "GSM",
          ];
          distinctLine.map((msisdn: string) => {
            const exp = permissionInfo.explicitPermissions?.filter(
              (exp: ExplicitPermissions) => exp.msisdn === msisdn
            );
            let impLine: Lines[] = [];
            const linkedLine: Lines[] = implicitPermLines.filter(
              (line: Lines) =>
                line.permissionType.toLocaleLowerCase() === "linked"
            );
            if (
              linkedLine.some(
                (linked_line: Lines) => linked_line.msisdn === msisdn
              )
            ) {
              impLine = implicitPermLines.filter(
                (type: Lines) =>
                  type.msisdn === msisdn &&
                  type.permissionType.toLocaleLowerCase() === "linked"
              );
            } else {
              impLine = implicitPermLines.filter(
                (type: Lines) => type.msisdn === msisdn
              );
            }
            //checking editable and shareable option
            //UD-3170 UD-3363 UD-3362
            let checkEditAndShare: Lines[] = [];
            let checkEditAndShareLenght = 0;

            const filter_type = lineDetails.filter(
              (type: Lines) => type.MSISDN === msisdn
            );
            if (filter_type.length > 0) {
              let line: Lines = {
                ...filter_type[0],
                ...exp?.[0],
                ...impLine?.[0],
              };
              if (!line?.givenName) {
                line.givenName = "Unnamed";
              } else {
                line.givenName = line.givenName;
              }
              if (line.LineType) {
                if (line.LineType === "VIRTUAL") {
                  line.Icon = "VirtualLine";
                } else if (line.LineType === "DUPLICATE") {
                  line.Icon = "Wearable";
                } else {
                  line.Icon = "PhoneIphoneIcon";
                }
              }

              if (impLine.length > 0) {
                if (
                  !(
                    line.MSISDN === "" ||
                    (line.LineType &&
                      (line.LineType.toLocaleLowerCase().trim() ===
                        "conference" ||
                        line.LineType.toLocaleLowerCase().trim() ===
                          "autoattendant")) ||
                    (line.NAPLineType &&
                      line.NAPLineType.toUpperCase().trim() === "MI") ||
                    (line.LineSubType &&
                      (line.LineSubType.toUpperCase().indexOf("PRMBMW") !==
                        -1 ||
                        line.LineSubType.toUpperCase().indexOf("SECBMW") !==
                          -1))
                  )
                ) {
                  if (
                    required_linesTypes.some((types) => line.LineType === types)
                  ) {
                    if (
                      (line.granteeEmail === userEmail &&
                        line.grantor === line.grantee) ||
                      (line.permissionType &&
                        line.permissionType.toLowerCase() === "linked")
                    ) {
                      checkEditAndShare = implicitPermLines.filter(
                        (type: Lines) => type.msisdn === msisdn
                      );
                      checkEditAndShareLenght = checkEditAndShare.length;

                      /// Is Line sharable changes Start
                      line.isShareble = false;
                      if (checkEditAndShare.length === 1) {
                        line.isShareble =
                          checkEditAndShare[0].isLineGrantable === "true" &&
                          line.LineType === "VIRTUAL";
                      } else {
                        const checkGrantTrue = checkEditAndShare.filter(
                          (type: Lines) => type.isLineGrantable === "true"
                        );
                        if (checkGrantTrue.length > 0) {
                          if (
                            checkGrantTrue.length === checkEditAndShareLenght &&
                            line.LineType === "VIRTUAL"
                          ) {
                            line.isShareble = true;
                          } else {
                            const checkPermissionType = checkEditAndShare.filter(
                              (type: Lines) =>
                                type.permissionType.toLocaleLowerCase() ===
                                  "inherited" ||
                                type.permissionType.toLocaleLowerCase() ===
                                  "linked"
                            );
                            if (
                              checkPermissionType.length ===
                                checkEditAndShareLenght &&
                              line.LineType === "VIRTUAL"
                            ) {
                              line.isShareble = true;
                            }
                          }
                        }
                      }
                      ///is Line Shareble End

                      // line.isShareble =
                      //   checkEditAndShare.filter(
                      //     (type: Lines) => ((type.isLineGrantable === "true") ||
                      //      (type.permissionType.toLocaleLowerCase()==="inherited" && type.permissionType.toLocaleLowerCase()==="linked"))
                      //   ).length === checkEditAndShareLenght
                      //     ? true
                      //     : false;
                      line.isEditable = true;
                      assignedLines.push(line);
                    }

                    if (line.isLineGrantable.toLocaleLowerCase() !== "false") {
                      if (
                        line.granteeEmail === userEmail &&
                        line.grantor !== line.grantee
                      ) {
                        line.isEditable = false;
                        line.isShareble = false;
                        sharedLines.push(line);
                      }
                      if (
                        !line.grantee &&
                        line.permissionType &&
                        line.permissionType.toLocaleLowerCase() !== "linked"
                      ) {
                        //checking editable and shareable option
                        //UD-3170 UD-3363
                        checkEditAndShare = implicitPermLines.filter(
                          (type: Lines) => type.msisdn === msisdn
                        );
                        checkEditAndShareLenght = checkEditAndShare.length;
                        line.isEditable =
                          checkEditAndShareLenght > 0 ? true : false;
                        line.isShareble =
                          checkEditAndShare.filter(
                            (type: Lines) =>
                              type.isLineGrantable === "true" &&
                              type.LineType === "VIRTUAL"
                          ).length === checkEditAndShareLenght
                            ? true
                            : false;
                        unAssignedLines.push(line);
                      }
                    }
                  }
                  if (line.LineType === "DUPLICATE") {
                    if (
                      implicitPermLines.filter(
                        (type: Lines) => type.msisdn === msisdn
                      ).length > 0
                    ) {
                      line.isEditable = true;
                    } else {
                      line.isEditable = false;
                    }
                    line.isShareble = false;
                    dublicateLines.push(line);
                  }
                }
              } else {
                if (
                  (line.granteeEmail === userEmail &&
                    line.grantor === line.grantee) ||
                  (line.permissionType &&
                    line.permissionType.toLowerCase() === "linked")
                ) {
                  checkEditAndShare = implicitPermLines.filter(
                    (type: Lines) => type.msisdn === msisdn
                  );
                  checkEditAndShareLenght = checkEditAndShare.length;
                  line.isEditable = true;
                  line.isShareble =
                    checkEditAndShare.filter(
                      (type: Lines) =>
                        type.isLineGrantable === "true" &&
                        type.LineType === "VIRTUAL"
                    ).length === checkEditAndShareLenght
                      ? true
                      : false;
                  assignedLines.push(line);
                }
                if (
                  line.granteeEmail === userEmail &&
                  line.grantor !== line.grantee
                ) {
                  line.isEditable = false;
                  line.isShareble = false;
                  sharedLines.push(line);
                }
              }
            }
          });
        } else {
          return lineDetailsError;
        }
      }
      const content = ComponentsContent?.Home;
      lines_details.push({
        id: 1,
        category: "Paired Devices",
        lines: dublicateLines,
        helpText: content.linesHelperText.Paired,
      });
      lines_details.push({
        id: 2,
        category: "Assigned Lines",
        lines: assignedLines,
        helpText: content.linesHelperText.Assigned,
      });
      lines_details.push({
        id: 3,
        category: "Unassigned Lines",
        lines: unAssignedLines,
        helpText: content.linesHelperText.Unassigned,
      });

      lines_details.push({
        id: 4,
        category: "Lines Shared with me",
        lines: sharedLines,
        helpText: content.linesHelperText.Shared,
      });

      return (config.userLines = { lines_details, count });
    } else {
      return permissionInfo;
    }
  };

  this.getLineDelveDetails = async (payload: number) => {
    const response = await DAASLAYER.HTTP(
      apis.lineDelveDetail + payload,
      "GET",
      "fetch line delve details"
    );
    if (!response?.errors) {
      return response; //.map((r: ExplicitPermissions) => r.granteeEmail)
    }
    throw response?.e?.message;
  };

  this.getManageDevicesDetails = async (payload: string) => {
    const response = await DAASLAYER.HTTP(
      apis.devices + "?ownerId=" + payload + "&additionalInfo=DIGITSPortal",
      "GET",
      "Get Manage Devices Details"
    );

    if (!response?.errors && response?.deviceProfileList) {
      return { data: response.deviceProfileList, status: 200 };
    }
    if (
      response?.errorCode === "53001" ||
      response?.errorMsg === "Cannot find the devices profile"
    ) {
      return { data: [], status: 404 };
    }
    throw response?.e?.message;
  };

  this.signingOutDevice = async (payload: Devices) => {
    const response = await DAASLAYER.HTTP(
      apis.devices +
        "?ownerId=" +
        payload.ownerId +
        "&deviceId=" +
        payload.deviceId +
        "&additionalInfo=DIGITSPortal",
      "DELETE",
      "Signing Out Device"
    );

    if (
      response.errors &&
      response.errorCode === "52101" &&
      response?.errorMsg === "Can't find specific devices"
    ) {
      return "404";
    }
    if (response) {
      return response?.errorMsg ? false : true;
    }
    throw response?.e?.message;
  };

  this.redirectToEUILogout = () => {
    window.location.href = apis.logoutEUI;
  };

  this.logout = async () => {
    const response = await DAASLAYER.HTTP(apis.logout, "DELETE", "User Logout");
    if (response) {
      localStorage.clear();
      sessionStorage.clear();
      DAASLAYER.redirectToLoginPage();
    }
    throw response?.e?.message;
  };

  this.removeGranteeEmail = async (payload: any) => {
    const response = await DAASLAYER.HTTP(
      apis.removeDelveDetail +
        payload,
      "DELETE",
      "remove Grantee Email"
    );
    if (!response?.errors) {
      return response;
    }
  };

  this.pairLine = async (deviceNumber: string, payload: any) => {
    const response = await DAASLAYER.HTTP(
      apis.linePair + deviceNumber,
      "PUT",
      "pair Line",
      null,
      {'Content-Type' : 'application/xml'},
      payload
    );
    if (!response?.errors) {
      return response;
    }
    throw response?.e?.message;
  };

  this.getLinePair = async (query: string) => {
    const response = await DAASLAYER.HTTP(
      apis.linePair + query,
      "GET",
      "get Line Pair"
    );
    if (!response?.errors) {
      return response;
    }
    if (response?.error === "GET_MSIM_DOC-CDB_NWKERR") {
      return null;
    }
    throw response?.e?.message;
  };

  this.unpairLine = async (payload: string) => {
    const response = await DAASLAYER.HTTP(
      apis.linePair + payload,
      "DELETE",
      "un pair a line"
    );
    if (!response?.errors) {
      return response;
    }
    throw response?.e?.message;
  };

  this.updateLineName = async (msisdn: string, payload: string) => {
    const response = await DAASLAYER.HTTP(
      apis.lineUpdate + "/" + msisdn,
      "PUT",
      "update Line Name",
      payload
    );
    if (!response?.errors) {
      return response;
    }
  };

  this.getLineName = async (msisdn: string) => {
    const response = await DAASLAYER.HTTP(
      apis.lineUpdate + "/" + msisdn,
      "GET",
      "Get Line Name"
    );
    if (!response?.errors) {
      return response;
    }
  };

  this.getDeviceList = async (payload: any) => {
    const response = await DAASLAYER.HTTP(
      apis.devicesList + payload + "&additionalInfo=DIGITSPortal",
      "GET",
      "Get Device List"
    );
    if (!response?.errors) {
      return response;
    }
  };

  this.deactivateLine = async (payload: any) => {
    const response = await DAASLAYER.HTTP(
      apis.devicesList + payload + "&additionalInfo=DIGITSPortal",
      "DELETE",
      "Deactivate Line"
    );
    if (!response?.errors) {
      return response;
    }
    throw response?.e?.message;
  };

  this.getPrimaryDevice = async (payload: any) => {
    const response = await DAASLAYER.HTTP(
      apis.primaryDevice + payload,
      "GET",
      "Get Primary Device"
    );
    if (!response?.errors) {
      return response;
    }
  };

  this.getInvitationInfo = async (payload: any) => {
    const request = {
      grantor_email: payload.data.grantorEmail,
      grantee_email: payload.data.granteeEmail,
      lineType: payload.data.lineType,
      MSISDN: payload.data.msisdn,
      privilege: "Full",
    };
    return (config.userInfo = await DAASLAYER.HTTP(
      apis.invitationInfo,
      "POST",
      "Get Invitation Info",
      request
    ));
  };

  this.sendEmail = async (payload: any, lines: any) => {
    await this.sendGranteeEmail(payload);
    await this.sendEMLinesOthersEmails(lines, payload);
    let xml_payload = ``;

    xml_payload = payload.isRevoke ? emLineOwnerRevoked : emLineSharedOwner;

    xml_payload = xml_payload.replace("$msisdn_value", payload.msisdn);
    xml_payload = xml_payload.replace("$msisdn_value", payload.msisdn);
    xml_payload = xml_payload.replace("$tmoid_emailId", payload.granteeEmail);
    xml_payload = xml_payload.replace("$first_Name", payload.ownerFirstName);
    xml_payload = xml_payload.replace(
      "$receiver_emailId",
      payload.grantorEmail
    );
    return await DAASLAYER.HTTP(
      apis.sendEmail,
      "POST",
      "send Email",
      null,
      {},
      xml_payload
    );
  };

  this.sendEMLinesOthersEmails = async (lines: any, payload: any) => {
    let explicitEmails: string[] = [];
    let implicitEmails: string[] = [];
    if (lines.explicitPermissions) {
      explicitEmails = lines?.explicitPermissions?.map(
        (r: ExplicitPermissions) => r.granteeEmail
      );
    }
    if (lines.implicitPermissions) {
      lines?.implicitPermissions?.map((r: ImplicitPermissions) => {
        if (r.user?.IAMEmail) {
          implicitEmails.push(r.user.IAMEmail);
        }
      });
    }

    const emailsToSend = [...explicitEmails, ...implicitEmails];
    emailsToSend.map(async (email: string) => {
      if (email !== payload.granteeEmail && payload.grantorEmail !== email) {
        let xml_payload = ``;
        xml_payload = payload.isRevoke
          ? emLineOthersRevoked
          : emLineSharedWithOthers;
        xml_payload = xml_payload.replace("$msisdn_value", payload.msisdn);
        xml_payload = xml_payload.replace("$msisdn_value", payload.msisdn);
        xml_payload = xml_payload.replace(
          "$tmoid_emailId",
          payload.granteeEmail
        );
        xml_payload = xml_payload.replace(
          "$tmoid_emailId_owner",
          payload.grantorEmail
        );
        xml_payload = xml_payload.replace("$first_Name", "");
        xml_payload = xml_payload.replace(
          "$owner_Name",
          payload.ownerFirstName
        );

        xml_payload = xml_payload.replace("$receiver_emailId", email);
        await DAASLAYER.HTTP(
          apis.sendEmail,
          "POST",
          "send Email",
          null,
          {},
          xml_payload
        );
      }
    });
  };

  this.sendGranteeEmail = async (payload: any) => {
    let xml_payload = ``;
    xml_payload = this.userTemplateWithValues(payload);
    if (payload.redirectUrl) {
      xml_payload = xml_payload.replace("$redirect_url", payload.redirectUrl);
    }
    await DAASLAYER.HTTP(
      apis.sendEmail,
      "POST",
      "send Grantee Email",
      null,
      {},
      xml_payload
    );
  };

  this.userTemplateWithValues = (payload: any) => {
    let xml_payload = ``;
    if (payload.isRevoke) {
      xml_payload = emLineUserRevoked;
      xml_payload = xml_payload.replace("$tmoid_emailId", payload.granteeEmail);
    } else {
      xml_payload = payload.redirectUrl
        ? emLineWithOutTMOID
        : emLineUserWithTMOID;
    }
    xml_payload = xml_payload.replace("$msisdn_value", payload.msisdn);
    xml_payload = xml_payload.replace("$msisdn_value", payload.msisdn);
    xml_payload = xml_payload.replace(
      "$tmoid_emailId_owner",
      payload.grantorEmail
    );
    xml_payload = xml_payload.replace(
      "$receiver_emailId",
      payload.granteeEmail
    );
    return xml_payload;
  };
};

const consumerSDK = new (SDK as any)();
export default consumerSDK;
